<template>
  <b-button icon @click="toggleLang">
    <img
      :src="locale === 'fr' ? flagFr : flagEn"
      alt="flag"
      width="24"
      height="24"
      cover
    />
  </b-button>
</template>

<script >

export default {
  name: 'InterParcel',
  components:{},
  data() {
    return {
      flagFr:'flags/fr.png',
      flagEn:'flags/en.png'
    }
  },
  computed:{
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: { 
    toggleLang() {
      this.$i18n.locale = this.locale === 'fr' ? 'en' : 'fr'
      localStorage.setItem('lang', this.locale)
    }
  }
}
</script>
